// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
//
// Sentry disabled (intentionally) — config preserved as comments for easy re-enable.

// import * as Sentry from '@sentry/nextjs';

// Sentry.init({
//   dsn: 'https://bcd2c42571091cc03edd6aeb48d91925@o420741.ingest.us.sentry.io/4510743917559809',
//
//   // Release must match the one used during build for source map matching
//   release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
//
//   // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
//   tracesSampleRate: 1,
//   // Enable logs to be sent to Sentry
//   enableLogs: true,
//
//   // Enable sending user PII (Personally Identifiable Information)
//   // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
//   sendDefaultPii: true,
// });

export const onRouterTransitionStart = () => {
  // Sentry disabled (intentionally).
};

// Sentry wiring (disabled):
// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
